import { render, staticRenderFns } from "./FilterForClients.vue?vue&type=template&id=57809bec&scoped=true&"
import script from "./FilterForClients.vue?vue&type=script&lang=js&"
export * from "./FilterForClients.vue?vue&type=script&lang=js&"
import style0 from "./FilterForClients.vue?vue&type=style&index=0&id=57809bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57809bec",
  null
  
)

export default component.exports